import { LOCAL_STORAGE_USER_KEY } from '../utils/consts';
import { PimsUser } from '../utils/types/dataTypes';
import { authApi } from './authApi';

const storePimsUser = (data: PimsUser) => {
    window.localStorage.setItem(
        LOCAL_STORAGE_USER_KEY,
        JSON.stringify({
            ...data,
        }),
    );
};

// Define a service using a base URL and expected endpoints
export const authService = authApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserData: builder.query<PimsUser | undefined, null>({
            query: () => ({
                url: `me`,
                responseHandler: async (response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        // If response returns an error return an empty result with no User set
                        return {};
                    }
                },
                validateStatus: (response, result) => {
                    // This may be an issue in the future this is a temp fix to make sure that it returns a result and updates the tags if the user isn't signed in
                    if (response.ok || response.status === 401) {
                        return true;
                    } else {
                        return false;
                    }
                },
            }),
            providesTags: (result, error, id) => {
                return [{ type: 'SELF' }];
            },
            transformResponse: (response: { data: PimsUser | undefined }) => {
                if (response.data === undefined) {
                    // if user isn't logged in return undefined
                    return undefined;
                }
                // Only set a user if the user is actually logged in
                storePimsUser(response.data);
                return response.data;
            },
        }),
        login: builder.mutation<PimsUser, { username: string; password: string }>({
            query({ username, password }) {
                return {
                    url: `login`,
                    method: 'POST',
                    body: {
                        email: username,
                        password_hash: password,
                    },
                };
            },
            invalidatesTags: (result, error) => [{ type: 'SELF' }],
            transformResponse: (response: { data: PimsUser }) => {
                storePimsUser(response.data);
                return response.data;
            },
        }),
        logout: builder.mutation<null, null>({
            query() {
                return {
                    url: `logout`,
                    method: 'PUT',
                };
            },
            invalidatesTags: (result, error) => [{ type: 'SELF' }],
            transformResponse: () => {
                window.localStorage.setItem(LOCAL_STORAGE_USER_KEY, '');
                return null;
            },
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const { useGetUserDataQuery, useLoginMutation, useLogoutMutation } = authService;
